import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import VehicleMakesTableContainer from '../../../modules/vehicleMakes/components/VehicleMakesTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import { hasPermission } from '../../../utils/HelperFunctions';

const VehicleMakes = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/makes',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.vehicle_makes'),
    withPagination: true,
    queryKey: 'vehicle-makes'
  });

  const tableHeaders = [
    { label: t('icon'), customClass: 'logo' },
    { label: t('name') },
    hasPermission(['makes.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="vehicleMakes-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">{searchEle}</div>
        <Button text={t('create_vehicle_make')} link="/vehicle-makes/create-vehicle-make" />
      </ListHeader>
      <VehicleMakesTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_vehicle_makes_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default VehicleMakes;
